import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

import createPersistedState from "vuex-persistedstate";

//import SecureLS from "secure-ls";
//var ls = new SecureLS({ isCompression: false });
Vue.use(Vuex)

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
  
  plugins: [createPersistedState( 
    /* {
      key:"ecampus",
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }*/
  ),]
})

export default store

